/*
 * @Author: 向南星 xiangnanxing@scmagic.cn
 * @Date: 2022-09-19 13:56:15
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2022-11-02 14:51:13
 */
import { EasTabItem, EasTabs } from '@easyvaas/react-components';
import { useTitle } from '@easyvaas/react-hooks';
import React from 'react';
import { classNames } from 'src/utils/classNames';
import styles from './index.module.scss';
import MyImages from '../../components/MyImages';
import EvolutionPopup from '../../components/EvolutionPopup';
import AbilitiesPopup from '../../components/AbilitiesPopup';
import ExchangePopup from '../../components/ExchangePopup';
import ResetPopup from '../../components/ResetPopup';
import { useRecoilState, useRecoilValue } from 'recoil';
import PresentPopup from '../../components/PresentPopup';
import UpgradePopup from '../../components/UpgradePopup';
import ShopImages from '../../components/ShopImages';
import TransformPopup from '../../components/TransformPopup';
import ImageRank from '../../components/ImageRank';
import { myImagesListSelector } from '../../store/selector';
import ComposePopup from '../../components/ComposePopup';
import PolishPopup from '../../components/PolishPopup';
import ResultPopup from '../../components/ResultPopup';
import { mainTabState } from '../../store/state';
import { useHistory, useLocation } from 'react-router-dom';
import MyRankPanel from '../../components/MyRankPanel';
import PropComposePopup from '../../components/PropComposePopup';
const ImageV3: React.FC = () => {
  useTitle('座驾');
  const mainTab = useRecoilState(mainTabState);
  const myImages = useRecoilValue(myImagesListSelector);
  const history = useHistory();
  const location = useLocation();
  return (
    <div className={styles.container}>
      <div className={styles.count}>已获座驾({myImages.length})</div>
      <button
        className={styles.rule}
        onClick={() =>
          history.push({
            pathname: 'imagesv3/rules',
            search: location.search,
            state: { from: location.pathname }
          })
        }
      >
        规则说明
      </button>
      <button
        className={styles.history}
        onClick={() =>
          history.push({
            pathname: 'imagesv3/history',
            search: location.search,
            state: { from: location.pathname }
          })
        }
      >
        获取记录
      </button>
      <EasTabs
        className={styles.mainTabs}
        tabControl={mainTab}
        tabbarClassName={classNames([
          styles.tabbar,
          styles[`active${mainTab[0]}`]
        ])}
        tabbarItemClassName={styles.item}
        tabbarItemActiveClassName={styles.active}
      >
        <EasTabItem title="座驾排行">
          <ImageRank />
        </EasTabItem>
        <EasTabItem title="座驾获取">
          <ShopImages />
        </EasTabItem>
        <EasTabItem title="我的座驾">
          <MyImages />
        </EasTabItem>
      </EasTabs>
      <AbilitiesPopup />
      <ExchangePopup />
      <EvolutionPopup />
      <ResultPopup />
      <PresentPopup />
      <UpgradePopup />
      <ResetPopup />
      <TransformPopup />
      <ComposePopup />
      <PolishPopup />
      <MyRankPanel />
      <PropComposePopup />
    </div>
  );
};

export default ImageV3;
